"use strict";
var ArrayObservable_1 = require('./ArrayObservable');
exports.of = ArrayObservable_1.ArrayObservable.of;
//# sourceMappingURL=of.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/observable/of.js
// module id = 822
// module chunks = 4